// extracted by mini-css-extract-plugin
module.exports = {"main":"main--RSbsZ","content":"content--CQDjh"};